import { useForm } from "react-hook-form";
import { Grid, TextField, Typography } from "@mui/material";
import ReadMoreReadLess from "../../app/common/ReadMoreReadLess";
import { AnswersProps } from "../../app/models/Answers";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const schema = yup.object().shape({
  observing: yup
    .string()
    .required("Must give an answer")
    .max(500, "Max characters reached"),
});

const ObservationMethod: React.FC<AnswersProps> = ({
  answersData,
  onAnswerChange,
}) => {
  const defaultValues = {
    observing: answersData.find((answer) => answer.systemCodeId === 252)
      ?.answer,
  };
  const {
    register,
    formState: { errors },
  } = useForm({
    defaultValues,
    resolver: yupResolver(schema),
    mode: "onTouched",
  });

  const renderObservationMethodCompetence = () => {
    return (
      <>
        <li>How do you document the observations you conduct?</li>
        <li>
          What strategies do you apply to ensure observations are not based on
          personal experiences or opinions?
        </li>
        <li>
          What strategies do you use to connect to make certain observations are
          not biased based on cultural background?
        </li>
      </>
    );
  };

  return (
    <Grid container p={2} m={1} mb={2} bgcolor="compV.light">
      <Grid item xs={12}>
        <Typography fontSize={18} fontWeight={700} mb={2}>
          Observation Method
        </Typography>
        <Typography mb={2}>
          How do you ensure that you are accurately/objectively observing and
          tracking each child's developmental and learning progress?
        </Typography>
        <ReadMoreReadLess>
          <>{renderObservationMethodCompetence()}</>
        </ReadMoreReadLess>
      </Grid>
      <Grid item xs={12}>
        <TextField
          {...register("observing")}
          name="observing"
          label="The way I ensure that I am accurately/objectively observing and tracking each child’s developmental and learning program is"
          fullWidth
          multiline
          sx={{ backgroundColor: "white" }}
          rows={2}
          value={
            answersData.find((answer) => answer.systemCodeId === 252)?.answer ||
            ""
          }
          onChange={(e) => {
            const newValue = e.target.value;
            const systemCodeId = 252;

            newValue.length <= 500 && onAnswerChange(systemCodeId, newValue);
          }}
          error={!!errors.observing?.message}
          helperText={errors.observing?.message}
        />
        <Typography fontSize={13}>
          {defaultValues.observing?.length}/500
        </Typography>
      </Grid>
    </Grid>
  );
};
export default ObservationMethod;
